import {
    ajax,
    ajaxP,
    request,
    ajaxBack,
    imgRequest
} from '@/utils/request'



// 校验车牌号是否可以查询
export function checkNum(num) {
    return ajax(`api/v1/vio/h5/carNumber`, {
        carNumber: num
    })
}

// 车辆列表
export function breakCarList() {
    return ajax('api/v1/vio/h5/customerCarVio')
}

// 新增车辆
export function addCar(params) {
    return ajaxP(`api/v1/customer/car/h5`, params)
}

// 删除车辆
export function delCar(id) {
    return ajaxBack({
        url: `api/v1/customer/car/h5/${id}`,
        method: 'DELETE'
    })
}

// 车辆违章信息
export function breakList(params) {
    params.toastMessage = '查询中...';
    return ajaxBack({
        url: `api/v1/vio/h5/list`,
        method: "get",
        params: params
    }, false, true)
}

// 车辆历史违章信息
export function breakHistory(params) {
    return ajax('api/v1/vio/h5/his/list', params)
}

// 驾照列表
export function drivingList() {
    return ajax('api/v1/license/score/list', {
        toastMessage: '查询中...'
    })
}

// 新增驾照
export function addDriving(params) {
    return ajaxP(`api/v1/customers/driveLicense`, params)
}

// 驾照查分
export function drivingInfo(id) {
    return ajaxBack({
        url: `api/v1/license/score/refresh/${id}`,
        method: "get",
        params: {
            toastMessage: '查询中...'
        }
    }, false, true)
}

// 删除驾照
export function delDriving(id) {
    return request({
        url: `api/v1/customers/driveLicense/${id}`,
        method: 'DELETE'
    })
}

// 图片识别
export function ocr(url) {
    return imgRequest({
        url: ``,
        method: "get",
        params: {
            toastMessage: '正在识别中',
            name: url
        }
    })
}